export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";